module.exports = __webpack_public_path__ + "static/media/5.e5a7790a.gif";